import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfCatalogUiModule } from '@df/catalog-ui/df-catalog-ui.module';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { CmsBlogPostComponent } from '../../../../../cms/blog/post/cms-blog-post.component';
import { CustomCursorComponent } from '../../../../../ui/display/custom-cursor/custom-cursor.component';
import { CategoryComponent } from '../../../category/category.component';
import { ProductComponent } from '../../../product/product.component';
import { LocalModelCarouselComponent } from '../local-model-carousel/local-model-carousel.component';
import { getFields } from '../local-model-carousel/local-model-carousel.config';

@Component({
    selector: 'page-component-category-carousel',
    templateUrl: './../local-model-carousel/local-model-carousel.html',
    styleUrl: './../local-model-carousel/local-model-carousel.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CategoryComponent,
        CmsBlogPostComponent,
        CommonModule,
        CustomCursorComponent,
        DfCatalogUiModule,
        DfImageDirective,
        DfImageWrapperComponent,
        CarouselComponent,
        CarouselSlideDirective,
        GtmTrackViewItemListDirective,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        forwardRef(() => ProductComponent),
        RouterModule,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentCategoryCarouselComponent>({
    id: 'category-carousel-v1',
    name: 'Category Carousel (Variant 1)',
    image: 'assets/images/cms/category-carousel.png',
    tags: ['images', 'carousel', 'slider', 'product'],
    fields: getFields('category', undefined, true, true)
})
export class PageComponentCategoryCarouselComponent extends LocalModelCarouselComponent<Category<ICategoryDataV2>> {
    override type = 'category';

    override ngOnInit() {
        super.ngOnInit();

        this.subscriptions.add(this.app.meta.subscribe(() => this.updateCanShow()));

        this.updateCanShow();
    }

    private updateCanShow() {
        this.canShow.set(!this.app.meta.state?.metaData?.level);
        this.detectChanges();
    }
}
